<div class="banner-container">
    <kw-banner-wrapper class="grid-cell-container" [ngClass]="heightCls" [attr.cell-id]="selectedCell?.cellId">
        <ng-container *ngIf="!edit; else editing">
            <ng-container *ngTemplateOutlet="bannerContent"></ng-container>
            <!-- <div class="bg-img-layer" [style.--bg-image]="bgImgSrc"></div>
            <kw-fill-layer-renderer [fillClass]="selectedCell?.fillClass" [fillColor]="selectedCell?.fillColor" [heightCls]="heightCls"></kw-fill-layer-renderer>
            <kw-wrapper [wrapperClass]="wrapperClass" class="content-layer">
                <div class="horizontal-position" [ngClass]="selectedCell?.cellHorizontalAlign" [ngStyle]="{'height':''+contentHeight+''}">
                    <div class="content-layout" [ngClass]="selectedCell?.layoutClass" [style.--content-layout-width]="selectedCell?.contentWidth">
                        <div *ngFor="let contentElement of contentElements" [ngClass]="contentElement.containerClasses">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </div>
                </div>
            </kw-wrapper> -->
        </ng-container>
        <ng-template #editing>
            <ng-container *ngIf="selectedCell.status === 'Initial Draft';else inProgress">
                <ng-container *ngTemplateOutlet="bannerContent"></ng-container>
                <!-- <div class="bg-img-layer" [style.--bg-image]="bgImgSrc"></div>
                <kw-fill-layer-renderer [fillClass]="selectedCell?.fillClass" [fillColor]="selectedCell?.fillColor" [heightCls]="heightCls"></kw-fill-layer-renderer>
                <kw-wrapper [wrapperClass]="wrapperClass" class="content-layer">
                    <div class="horizontal-position" [ngClass]="selectedCell?.cellHorizontalAlign" [ngStyle]="{'height':''+contentHeight+''}">
                        <div class="content-layout" [ngClass]="selectedCell?.layoutClass" [style.--content-layout-width]="selectedCell?.contentWidth">
                            <div *ngFor="let contentElement of contentElements" [ngClass]="contentElement.containerClasses">
                                <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                        </div>
                    </div>
                </kw-wrapper> -->
            </ng-container>
            <ng-template #inProgress>
                <kw-edit-placeholder-renderer [gridCell]="selectedCell" (createGridCellContent)="createContent($event)"></kw-edit-placeholder-renderer>
            </ng-template>
        </ng-template>
    </kw-banner-wrapper>
</div>
<ng-template #bannerContent>
    <div class="bg-img-layer" [style.--bg-image]="bgImgSrc"></div>
    <kw-fill-layer-renderer [fillClass]="selectedCell?.fillClass" [fillColor]="selectedCell?.fillColor" [heightCls]="heightCls"></kw-fill-layer-renderer>
    <kw-wrapper [wrapperClass]="wrapperClass" class="content-layer">
        <div class="horizontal-position" [ngClass]="selectedCell?.cellHorizontalAlign" [ngStyle]="{'height':''+contentHeight+''}">
            <div class="content-layout" [ngClass]="selectedCell?.layoutClass" [style.--content-layout-width]="selectedCell?.contentWidth">
                <div *ngFor="let contentElement of contentElements" [ngClass]="contentElement.containerClasses">
                    <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                </div>
            </div>
        </div>
    </kw-wrapper>
</ng-template>

